import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {Button} from 'primeng/button';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {TranslocoPipe} from '@jsverse/transloco';
import {FormFieldComponent} from '../../../../../../../../shared/components/inputs/form-field/form-field.component';
import {DirectusService} from '@frontend/directus';
import {toSignal} from '@angular/core/rxjs-interop';
import {FormFieldSelectButtonComponent} from '../../../../../../../../shared/components/inputs/form-field/form-field-submit-button/form-field-select-button.component';

@Component({
  imports: [
    ReactiveFormsModule,
    Button,
    TranslocoPipe,
    FormFieldComponent,
    FormFieldSelectButtonComponent,
  ],
  templateUrl: './upload-document-dialog.component.html',
})
export class UploadDocumentDialogComponent implements OnInit {
  private readonly directusService = inject(DirectusService);
  private readonly fb = inject(FormBuilder);
  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);

  protected readonly file = this.config.data.file as File | undefined;
  protected readonly isEditable = !!this.config.data.isEdit;

  readonly form = this.fb.group({
    originalFilename: [{value: '', disabled: true}],
    fileName: ['', [Validators.required]],
    version: ['v1.0', [Validators.required]],
    statusUuid: ['', [Validators.required]],
  });

  protected readonly uploadDocumentStatusOptions = toSignal(
    this.directusService.loadDirectusDropdown('rfq_invitation_upload_document_status'),
    {initialValue: []},
  );

  ngOnInit(): void {
    if (this.isEditable) {
      this.form.patchValue({
        originalFilename: this.config.data.originalFilename ?? '',
        fileName: this.config.data.fileName ?? '',
        version: this.config.data.version ?? 'v1.0',
        statusUuid: this.config.data.documentStatusUuid ?? '',
      });
    } else if (this.file) {
      this.form.patchValue({
        originalFilename: this.file.name,
        fileName: this.file.name,
      });
    }
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.ref.close({...this.form.getRawValue(), file: this.file});
  }

  onHideDialog(): void {
    this.ref.close();
  }
}
